import { createContext, useContext, useState, useEffect } from "react";

const SURFACE = {
  light: "#f5f3f8",
  dark: "#0c0a10",
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("theme");
    // Default is dark; only light when explicitly saved.
    return saved === "light" ? "light" : "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.removeAttribute("data-brand");
    document.documentElement.removeAttribute("data-palette");
    localStorage.setItem("theme", theme);
    localStorage.removeItem("appearance");
    localStorage.removeItem("brand-palette");

    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", SURFACE[theme]);
  }, [theme]);

  const setThemeMode = (next) => {
    if (next === "light" || next === "dark") setTheme(next);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme: setThemeMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
